<script lang="ts">
  import type { TabData } from './wrappers';

  export let isSelected: boolean;
  export let tabData: TabData;
  export let disabled = false;

  $: color = isSelected ? 'white' : '#67857E';
  $: bgColor = isSelected ? '#0B9D58' : 'transparent';
</script>

<button
  class="disabled:opacity-50 flex h-8 font-bold items-center justify-center py-3 px-4 gap-x-2 duration-200 rounded-full mr-px"
  style:background-color={bgColor}
  style:color
  on:click|stopPropagation
  {disabled}
>
  <svelte:component this={tabData.icon} {color} />

  {tabData.title}
</button>
